<template>
  <div class="tab-pane fade" id="affiliated" role="tabpanel" aria-labelledby="affiliated-tab">
    <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="caMoving"  size="6x"/>
    <div v-if="!caLoading && !showNewCA && !showModifyCA">
        <Tree
          :nodes="data"
          :config="config"
          @nodeChecked="nodeChecked"
          @nodeUnchecked="nodeUnchecked"
          @node-drop="nodeDrop"
        >
        </Tree>
        <div class="col-12 text-center mt-2 mt-md-4">
          <button class="btn btn-primary ml-2" :class="{ disabled: isDisabled }" @click="openCreateCAWindow">{{$t("Créer un nouveau compte affiliés")}}</button>
          <button class="btn btn-primary ml-2" :class="{ disabled: isDisabledCA }" @click="openModifyCA">{{$t("Modifier un compte affiliés")}}</button>
        </div>
    </div>
    <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="caLoading"  size="6x"/>
    <NewCa v-if="showNewCA" :curUser="selectedUser" :showNewCA="showNewCA" @closeNewCa="closeNewCa"></NewCa>
    <address-manager-ca :cur-user="selectedUser" v-if="showModifyCA" @closeModifyCA="closeModifyCA" @refreshUserList="refreshUserList"></address-manager-ca>
  </div>
</template>


<script>
import {ref} from 'vue';
import Tree from "vue3-treeview";
import "vue3-treeview/dist/style.css";

import NewCa from '@/components/NewCompteAffilie.vue'
import AddressManagerCa from './AddressManagerCA.vue';

export default {
  components: {
    Tree,
    NewCa,
    AddressManagerCa
  },
  mounted() {

  },
  props: ['curUser'],
  setup(props) {
    const selectedUser = ref(props.curUser);
    const caMoving =  ref(false);
    const showModifyCA = ref(false);
    const selected = [];
    const isDisabled = ref(true);
    const isDisabledCA = ref(true);

    const openModifyCA = function () {
      showModifyCA.value = true;
    }

    const closeModifyCA = function () {
      showModifyCA.value = false;
    }

    const nodeDrop =  function(ctx) {
      if (ctx.dragged.node.id === ctx.target.node) {
        return;
      }
      caMoving.value = true;
      let formData = new FormData();
      formData.append('username', ctx.dragged.node.id);
      formData.append('parent', ctx.target.node);
      fetch("api/moveca", {
          body: formData,
          method: "post"
      }).then(function(resp) {
        resp.json().then(function() {
            caMoving.value = false;
        }.bind(this));
      });
    }

    const openCreateCAWindow = function() {
      showNewCA.value = true;
    }
    const nodeChecked = function(node) {
      selectedUser.value = node.curUser;
      selected.forEach(function(elem) {
        elem.state.checked = false;
      });
      selected.length = 0;
      selected.push(node);
      isDisabled.value = false;
      isDisabledCA.value = false;
      if (selectedUser.value.username == props.curUser.username) {
        isDisabledCA.value = true;
      }
    }
    const nodeUnchecked = function() {
      selectedUser.value = props.curUser;
      selected.pop();
      isDisabled.value = true;
      isDisabledCA.value = true;
    }
    const showNewCA = ref(false);
    const data = ref({});

    const closeNewCa = function(){
        showNewCA.value = false;
    }

    const config = ref({
        roots: [props.curUser.username],
        dragAndDrop: true,
        checkboxes: true,
        checkMode: 'auto'
      });
    const caLoading = ref({});
    caLoading.value = true;

    function browseNodes(curNode, came_from_id) {
      if ('nodes' in curNode) {
        curNode['nodes'].forEach(element => {
          if ('username' in element) {
            if ( !('children' in data.value[came_from_id])) {
              data.value[came_from_id]['children'] = [];
            }
            data.value[came_from_id].children.push(element['username']);
            data.value[element['username']] = {
              'text': element.sn,
              'curUser': element
            }
            browseNodes(element, element['username']);
          }
        });
      }
    }
    const refreshUserList = function () {
      data.value[props.curUser.username] = {
          'text': props.curUser.sn,
          'curUser': props.curUser
          };
      fetch("api/getca", {
          body: {},
          method: "post"
      }).then(function(resp) {
        resp.json().then(function(json) {
          browseNodes(json, props.curUser.username);
          caLoading.value = false;
        }.bind(this));
      }.bind(this));
    }
    refreshUserList();
    return {
      isDisabledCA,
      isDisabled,
      showModifyCA,
      showNewCA,
      data,
      caLoading,
      config,
      openCreateCAWindow,
      nodeChecked,
      nodeDrop,
      closeNewCa,
      selectedUser,
      nodeUnchecked,
      caMoving,
      openModifyCA,
      closeModifyCA,
      refreshUserList
    }
  }
}
</script>
<style>

</style>